module.exports = "../images/angling-tips-for-walleye-fishing@2x.jpg?v=3f8988e";